import MerchantVerificationDocumentsPage from '../../../../components/merchant/verification-documents/MerchantVerificationDocumentsPage'

export default function VerifyDocuments() {
  return <MerchantVerificationDocumentsPage />
}
